/**
 * L'interrupteur global de la voix de BeBot, lisible côté navigateur comme côté
 * serveur (lib/bebotVoice.js, lui, est réservé au serveur).
 *
 * `BEBOT_VOICE` vit dans les deux blocs `env:` de next.config.mjs : sa valeur
 * est figée au build et recopiée dans le code du navigateur. L'interface s'en
 * sert pour retirer les réglages de voix quand il n'y a plus de voix à régler.
 *
 * ABSENTE OU VIDE = ACTIVÉ, comme dans lib/bebotVoice.js.
 */
export function isBebotVoiceOn() {
    const v = String(process.env.BEBOT_VOICE ?? "").trim().toLowerCase();
    return !["off", "0", "false", "no", "non"].includes(v);
}
